import {
  SCHEDULE_START_SYNCING_CALENDAR
} from 'infra/actions/types'

const startCalendarSync = (calendarId, dateStr) => ({
  type: SCHEDULE_START_SYNCING_CALENDAR,
  calendarId,
  dateStr
})

export default startCalendarSync



// WEBPACK FOOTER //
// ./src/infra/actions/calendars/startCalendarSync.js